// function changLocalUser(te, val) {
//   if (localStorage.getItem("MY_USER_BROSCASH")) {
//     const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
//     _my_user[te] = val;
//   } 
// }


function getMyIdUser() {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    return _my_user['id'];
  } else  {
    return "20";
  }
}
function getMyTokenUser() {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    return _my_user['token'];
  } else  {
    return "visitor12345678910";
  }
}
function getMyCodeCurrencynUser() {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    return _my_user['code_currency'];
  } else  {
    return "$";
  }
}

function getMyUserLocale(te) {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    return _my_user[te]
  } else  {
    return "visitor"
  }

}

function isLogin() {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    return 'yes'
  } else  {
    return "no"
  }
}

function checkDisconnect() {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    return _my_user['isDisconnect'];
  } else  {
    return 'no';
  }
}

export const _changLocalUser = (te, val) => {
  if (localStorage.getItem("MY_USER_BROSCASH")) {
    const _my_user = JSON.parse(localStorage.getItem("MY_USER_BROSCASH"));
    _my_user[te] = val;
    localStorage.setItem("MY_USER_BROSCASH", JSON.stringify(_my_user));
    setTimeout(() => {
      location.reload();
    }, 500);
  } 
};

export default {
  isLogin: isLogin(),
  id_user: getMyIdUser(), //localStorage.getItem('MY_LANG_BROSCASH') || 'en',
  user: getMyUserLocale('user'),
  wallet_link: getMyUserLocale('wallet_link'),
  token: getMyTokenUser(),
  balance: getMyUserLocale('balance'),
  code_currency: getMyCodeCurrencynUser(),
  check_security_code: getMyUserLocale('check_security_code'),
  isDisconnect: checkDisconnect(),
}